export default __webpack_public_path__ + "static/media/dia3.5b51c81d.png";